export const queryKeys = {
  user: (supabaseId: string) => ['user', supabaseId] as const,
  credits: (supabaseId: string) => ['credits', supabaseId] as const,
  userVideos: () => ['userVideos'] as const,
};
